import { render, staticRenderFns } from "./FormAvatarItem.vue?vue&type=template&id=f0cbfc04&scoped=true&"
import script from "./FormAvatarItem.vue?vue&type=script&lang=js&"
export * from "./FormAvatarItem.vue?vue&type=script&lang=js&"
import style0 from "./FormAvatarItem.vue?vue&type=style&index=0&id=f0cbfc04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cbfc04",
  null
  
)

export default component.exports